import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { AuthService } from 'src/app/services';
import { NgrxService } from 'src/app/services/ngrx/ngrx.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class ManageEmailService {
	public lastSearch = '';

	constructor(
		private http: HttpClient,
		private ngrxService: NgrxService,
		public authService: AuthService,
	) {}

	public loadCompanyListApi() {
		return this.ngrxService.loadInitAPI('company', 'mails');
	}

	public getCompanyListState() {
		return this.ngrxService.loadData('company', 'mails');
	}

	public loadCompanyListData(paginationOffset: number, str: string = 'a') {
		return this.getCompanyList(paginationOffset, str).pipe(
			tap(data => this.ngrxService.loadInitData('company', 'mails', data)),
		);
	}

	public getCompanyList(paginationOffset: number, str: string) {
		this.lastSearch = str || 'a';

		return this.http.get(
			environment.url.company +
				`/company/page/${paginationOffset}/limit/200/status/approved/search/${this.lastSearch}`,
		);
	}

	public deleteMember(memberId: number) {
		return this.http
			.delete(environment.url.company + `/company/email/${memberId}`)
			.pipe(
				tap(() => this.loadCompanyListData(0, this.lastSearch).subscribe()),
				tap(() =>
					this.authService.addToastMsg('Please reopen box. data updating..'),
				),
			);
	}

	public addMember(companyId: any, member: any) {
		return this.http
			.post(environment.url.company + `/company/${companyId}/email`, {
				...member,
			})
			.pipe(
				tap(() => this.loadCompanyListData(0, this.lastSearch).subscribe()),
				tap(() =>
					this.authService.addToastMsg('Please reopen box. data updating..'),
				),
			);
	}
}
